import React from 'react'
import * as R from 'ramda'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Typography from '../../../UniformComponents/Typography'
import InheritedChartSlot from './components/InheritedChartSlot'

const Inherited = ({ store }) => (
    <div className="pp-slide-layout-container">
        <div className="pp-slide-commentary-container">
            <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
        </div>

        <br />

        <div className="pp-chart-slots">
            <InheritedChartSlot
                store={store}
                key={`${store.activeSlide.id}-${0}`}
                position={0}
            />
        </div>

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 50 }}>
            <Typography type="tiny">
                {R.pathOr('', ['questionLongText'], store.activeSlide?.question.get(0))}
            </Typography>

            <Typography type="tiny">{i18n.t('powerpoint.slide.base-size')}</Typography>
        </div>
    </div>
)

export default observer(Inherited)
